export const bag = {
  'bag-title': `{orderType, select,
    pickup {Review your pickup order}
    outpost {Review your Outpost order}
    delivery {Review your delivery order}
    other {}
  }`,
  'bag.close': 'Close Bag',
  'bag.empty': 'Fill up your bag with the good stuff',
  'bag.view-menu': 'View menu',
  'bag.delivery-minimum': "You haven't met the {minimum} delivery minium yet.",
  'bag.upsells.header': 'Great additions',
  'bag.rewards.header': 'Choose your reward',
  'bag.rewards.footer': 'Rewards will be added at checkout',
  'bag.rewards.deadline-prefix': 'Ends',
  'bag.rewards.no-rewards': 'No rewards are available at the moment',
  'bag.rewards.error':
    'There was an issue with your rewards. Please try again later.',
  'bag.rewards.signed-out':
    'Sign in to use your available rewards. Don’t have an account? Create one and learn more about Rewards + Challenges.',

  'bag.lineItem.reward': 'Reward',
  'bag.lineItem.reward-calculated-at-checkout': 'Calculated at checkout',
  'bag.lineItem.dressing-on-the-side': 'Dressing on the side',
  'bag.lineItem.dressing-mixed-in': 'Dressing mixed in',
  'bag.lineItem.dressing-removed': 'No dressing',
  'bag.lineItem.with-bread': '+ Bread',
  'bag.lineItem.navigate-to': 'Navigate to "{lineItemName}" details page',
  'bag.rewards.disclaimer':
    '*Reward discounts and final tax will be applied at checkout',
  'bag.rewards.error.modal.headline': 'Oops, reward not applied',
  'bag.reorder.error-logged-out':
    'Please sign in to update your order location.',
  'bag.view-bag': 'View bag',
};
